import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage
import { encryptTransform } from 'redux-persist-transform-encrypt';
import thunk from 'redux-thunk';
import rootReducer from '../Reducer/index';
import tokenMiddleware from '../Middleware/TokenMiddleware';
import errorHandlingMiddleware from '../Middleware/ErrorHandlingMiddleware';


const encryptorConfig = {
  secretKey: process.env.REACT_APP_PERSIST_SECRET_KEY,
  onError: function (error) {
    console.error('Encryption error:', error);
  },
};


const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'auth', 
    'Ingest',
    'QuizValidate',
    'Reset',
    'GetTenant',
    'BookTenent',
    'ReleaseTenent',
    'ResetPageContent',
    'homePageContent',
    'alert',
    'AdminSharedTenantDetail',
  ],
  whitelist: [
    'Content', 
    'Demo_Catalgue',
    'FAQ_Question', 
    'LearningHubData',
    'whatNewReducer',
    'tenentDetails',
    'changePassword',
    'profile',
    'SalesPersonaHomepage',
    'ExistingDemoSession',
    'NewSalesDemoSession'
  ],
  transforms: [
    encryptTransform(encryptorConfig),
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  applyMiddleware(thunk, tokenMiddleware, errorHandlingMiddleware)
);

const persistor = persistStore(store);



export { store, persistor };


